<template>
  <!-- A settings field: label, «изменено» mark with a reset button for values changed in the interface.
       Values without the mark are the defaults. -->
  <div
    class="ai-setting"
    :class="{ 'is-inline': inline }"
  >
    <div
      class="ai-setting__head"
      :title="changed ? 'Изменено в интерфейсе' : 'Значение по умолчанию'"
    >
      <template v-if="!inline">
        <label
          class="ai-setting__label"
          :for="inputId"
        >
          {{ label }}
        </label>
        <span
          v-if="hint"
          class="ai-field__hint"
        >
          {{ hint }}
        </span>
      </template>
      <slot
        v-else
        :id="inputId"
      />
      <span
        v-if="changed"
        class="ai-setting__badge"
      >
        изменено
      </span>
      <button
        v-if="changed && !locked"
        type="button"
        class="ai-icon-button ai-setting__reset"
        title="Вернуть значение по умолчанию"
        :aria-label="`Вернуть значение по умолчанию: ${label}`"
        :disabled="busy"
        @click="$emit('reset')"
      >
        <ai-icon
          name="reset"
          :size="13"
        />
      </button>
    </div>
    <slot
      v-if="!inline"
      :id="inputId"
    />
    <span
      v-if="note"
      class="ai-setting__note"
    >
      {{ note }}
    </span>
  </div>
</template>

<script>
  import AiIcon from './AiIcon.vue';

  export default {
    name: 'SettingsField',
    components: { AiIcon },
    props: {
      label: { type: String, default: '' },
      hint: { type: String, default: '' },
      note: { type: String, default: '' },
      changed: { type: Boolean, default: false },
      locked: { type: Boolean, default: false },
      busy: { type: Boolean, default: false },
      // The slot is a whole checkbox label shown in the head row.
      inline: { type: Boolean, default: false },
    },
    computed: {
      inputId() {
        // eslint-disable-next-line no-underscore-dangle
        return `ai-setting-${this._uid}`;
      },
    },
  };
</script>

<style lang="scss" scoped>
  .ai-setting {
    display: flex;
    flex-direction: column;
    gap: 5px;
    min-width: 0;
  }

  .ai-setting__head {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 4px 8px;
    min-height: 20px;
  }

  .ai-setting__label {
    color: var(--ui-text);
    font-size: 13px;
    font-weight: 500;
  }

  .ai-setting__badge {
    padding: 0 7px;
    border-radius: 999px;
    background: var(--ui-primary-soft);
    color: var(--ui-primary);
    font-size: 11px;
    font-weight: 500;
    line-height: 18px;
  }

  .ai-icon-button.ai-setting__reset {
    width: 22px;
    height: 22px;
    margin-left: -4px;
  }

  .ai-setting__note {
    color: var(--ui-text-muted);
    font-size: 12px;
  }
</style>
